import { TOrganizationInvitationItem, TOrganizationItem } from "@/data/types";
import { State } from "../state/state";

export const getAllOrganizations = (state: State): TOrganizationItem[] =>
  state.organizations.items;

export const getCurrentOrganization = (
  state: State
): TOrganizationItem | null => state.organizations.currentOrganization;

export const getCurrentOrganizationInvitations = (
  state: State
): TOrganizationInvitationItem[] => state.organizations.invitations;
